<mat-dialog-content class="mat-typography">
    <div class="container form_wrapper">
        <div class="title_modal">
            {{ 'Duplicate Group' | translate }}
        </div>
        <form [formGroup]="form" class="form_with_pads form_with_valids">

            <mat-form-field appearance="standard" class="full_width_form">
                <mat-label>{{ 'Name' | translate }}</mat-label>
                <input formControlName="name" matInput placeholder="{{ 'Name' | translate }}">
            </mat-form-field>

            <mat-form-field appearance="standard" class="full_width_form">
                <mat-label>{{ 'Group description' | translate }}</mat-label>
                <textarea formControlName="description" matInput placeholder="{{ 'Group description' | translate }}"
                cdkTextareaAutosize
                [maxLength]="250"
                #autosize="cdkTextareaAutosize"
                cdkAutosizeMinRows="1"
                cdkAutosizeMaxRows="5"></textarea>
            </mat-form-field>
            
        </form>

        <div class="platforms form_with_pads">
            <div class="platform" *ngFor="let item of platformsData">
                <div class="plat_snippet">
                    <app-platform [platform_id]="item?.platform_id"></app-platform>
                    <span class="ml-1">{{getPlatformById(item?.platform_id)?.name}}</span>
                </div>

                <mat-form-field appearance="standard" class="full_width_form" style="width: 200px;">
                    <mat-label>{{"Content type" | translate}}</mat-label>
                    <mat-select [multiple]="false" #employeeIdContainer [(ngModel)]="item.content_type_id">
                        <ng-container *ngFor="let type of contentTypes">
                            <mat-option *ngIf="type.channel_platform_id == item.platform_id" [value]="type.id">
                                {{type?.name}}
                            </mat-option>
                        </ng-container>
                        
                    </mat-select>
                </mat-form-field>
            </div>
        </div>
    </div>
</mat-dialog-content>

<mat-dialog-actions align="end">
    <div class="f_w_p_btns">
        <button mat-button (click)="close()">
            {{ "Close" | translate }}
        </button>
        <button class="ml-1 d-f-btn" (click)="onSubmit()" cdkFocusInitial mat-raised-button color="primary" [disabled]="isSubmit">
            <mat-spinner class="spin_16 mr-1" *ngIf="isSubmit"></mat-spinner>  
            {{ "Duplicate" | translate }}
        </button>
    </div>
</mat-dialog-actions>
